
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t("payroll") }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
                <i class="fa fa-arrow-circle-o-left"></i> {{ $t("back") }}
            </button>
            <button class="btn btn-outline-primary btn-sm no-bor" @click="onAddNew">
                <i class="fa fa-plus-circle"></i> {{ $t("new") }}
            </button>
        </div>
        <div class="x_body">
            <div class="card x_card no-bor">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-1">
                            <div class="form-group">
                                <div>
                                    <select class="form-control form-control-sm" v-model="query.Year">
                                        <option v-for="ret in $years()" :key="ret" :value="ret">{{ ret }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-1">
                            <div class="form-group">
                                <div>
                                    <select class="form-control form-control-sm" v-model="query.Month">
                                        <option value="0">{{ $t("all") }}</option>
                                        <option v-for="ret in 12" :key="ret" :value="ret">{{ $t("month_" + ret) }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm no-bor" style="overflow-x: scroll">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 50px">{{ $t("no") }}</th>
                                <th>{{ $t("date") }}</th>
                                <th class="text-right">{{ $t("exchange_rate") }}</th>
                                <th>{{ $t("date_calculate") }}</th>
                                <th>{{ $t("date_approval") }}</th>
                                <th style="width: 90px">{{ $t("status") }}</th>
                                <th style="width: 60px"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{ index + 1 }}</td>
                                <td>
                                    <a v-if="ret.Status != 'Completed'" href="javascript:void(0)" @click="onEdit(ret)">{{ ret.OnYear }}/{{$number(ret.OnMonth, "00")}}</a>
                                    <span v-else>{{ ret.OnYear }}/{{$number(ret.OnMonth, "00")}}</span>
                                </td>
                                <td class="text-right">{{ $number(ret.ExchangeRate, "0,0.[00]") }}</td>
                                <td>{{$format(ret.DatePosted,'DD/MM/YYYY HH:mm A')}}</td>
                                <td>{{$format(ret.DateApproved,'DD/MM/YYYY HH:mm A')}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                                <td class="text-center">
                                    <router-link :to="{ name: 'payroll_preview',params: { id: ret.Id }}"><i class="fa fa-eye" aria-hidden="true"></i> View</router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <b-modal :no-close-on-backdrop="true" :title="$t('payroll')" size="sm" ref="innermodal">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <div>
                            <select class="form-control form-control-sm" v-model="model.OnYear">
                                <option v-for="ret in $years()" :key="ret" :value="ret">{{ ret }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group" :class="{ 'form-group-error': $v.model.OnMonth.$error }">
                        <div>
                            <select class="form-control form-control-sm" v-model="model.OnMonth">
                                <option v-for="ret in 12" :key="ret" :value="ret">{{ $t("month_" + ret) }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group" :class="{'form-group-error': $v.model.ExchangeRate.$error}">
                <label class="label-control blue">{{$t("exchange_rate")}}</label>
                <div>
                    <input type="number" class="form-control form-control-sm" v-model="model.ExchangeRate"/>
                </div>
            </div>
            <div slot="modal-footer">
                <b-btn variant="primary" size="sm" @click="onSave"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{ $t("save") }}</b-btn>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
export default {
    props: {},
    data: function () {
        return {
            query: {
                Year: new Date().getFullYear(),
                Month: 0,
            },
            records: [],
            model: {
                OnYear: "",
                OnMonth: "",
                ExchangeRate: 0,
            },
        };
    },
    validations: {
        model: {
            OnMonth: { required },
            ExchangeRate: { required },
        },
    },
    created: function () {
        this.toList();
    },
    methods: {
        toList: function () {
            let loading = this.$loading.show();
            this.$api().post("payrolls", this.query).then((res) => {
                if (this.$isValid(res)) {
                    this.records = res.data.Json.Payrolls;
                }
            }).finally(function () { loading.hide(); });
        },
        onAddNew: function () {
            this.model = {
                OnYear: this.query.Year,
                OnMonth: this.query.Month == "" ? new Date().getMonth() + 1 : this.query.Month,
            };
            this.$v.$reset();
            this.$refs.innermodal.show();
        },
        onSave: function () {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let loading = this.$loading.show();
                this.$api().post("payroll", this.model).then((res) => {
                    if (this.$isValid(res)) {
                        this.$refs.innermodal.hide();
                        this.toList();
                    }
                }).finally(function () { loading.hide(); });
            }
        },
        onEdit: function (item) {
            this.model = JSON.parse(JSON.stringify(item));
            this.$refs.innermodal.show();
        },
    },
};
</script>
